import React from 'react';
import { Skeleton } from '@mui/material';

/*
 * Loading placeholder for the home product sections. Shown while the initial
 * fetch is in flight so the page isn't blank on load (the product arrays start
 * as [], so the old CircularProgress fallback never rendered). Mirrors the
 * `.offers` layout: a section-title bar + a row of card-shaped skeletons.
 * Uses MUI <Skeleton> (themed); the global prefers-reduced-motion guard freezes
 * the wave animation for users who opt out.
 */

const cardWrap = {
  width: 280,
  maxWidth: '100%',
  borderRadius: 20,
  overflow: 'hidden',
  background: 'var(--surface, #fff)',
  boxShadow: 'var(--shadow-1, 0 1px 3px rgba(0,0,0,0.12))',
  flexShrink: 0,
  margin: 1,
};

const SkeletonCard = () => (
  <div style={cardWrap} aria-hidden="true">
    <Skeleton variant="rectangular" height={160} animation="wave" sx={{ width: '100%' }} />
    <div style={{ padding: 16 }}>
      <Skeleton variant="text" width="75%" height={26} animation="wave" />
      <Skeleton variant="text" width="45%" height={22} animation="wave" sx={{ mb: 1 }} />
      <Skeleton variant="rounded" height={36} animation="wave" sx={{ width: '100%' }} />
    </div>
  </div>
);

const ProductsSkeleton = ({ count = 5 }) => (
  <div style={{ width: '100%' }} aria-hidden="true">
    <div style={{ padding: '2vw var(--horizontal-padding, 10vw) 0' }}>
      <Skeleton variant="text" width={220} height={34} animation="wave" />
    </div>
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 20,
        padding: '2vw var(--horizontal-padding, 10vw)',
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  </div>
);

export default ProductsSkeleton;
